class Graphics {
    static blurForm(form)
    {
        form.prop('inert', true);
        form.append('<div class="blurring-overlay"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
    }

    static unblurForm(form)
    {
        form.prop('inert', false);
        form.find('.blurring-overlay').remove();
    }

    static unblurAllForms()
    {
        $('form[inert]').each((index, node) => {
            this.unblurForm($(node));
        });
    }
}

export default Graphics;
